import { api } from "@/services/api"

export type RetrieveInviteResponse = {
  firstName: string
  lastName: string
  phone: string | null
  email: string
}

export const retrieveInvite = async (
  inviteToken: string
) => {
  const { body } = await api.get<RetrieveInviteResponse>(
    `/invites/${inviteToken}/`
  )
  return body
}
